import { createContext } from 'react';

// AI-CONTEXT: See docs/features/livereport2-period-selector.md

/**
 * @typedef {object} PeriodRange
 * @property {string|null} start - ISO date 'YYYY-MM-DD' or null (unbounded)
 * @property {string|null} end - ISO date 'YYYY-MM-DD' or null (unbounded)
 */

/**
 * Carries the report's overall period (LiveReports2 Start/End, normalized to
 * ISO dates via `reportToPeriodRange`) into the widget tree. Data widgets
 * resolve their effective range from this value and their own period setting
 * with `resolveWidgetPeriod` (inherit / custom / all).
 *
 * Provided by all four render paths: the editor (LivereportTemplateBuilder),
 * the in-app viewer (LivereportTemplateViewer), and the public viewer
 * (LiveReportOpen2, where Start/End arrive serialized from
 * getPublicLiveReport2). Default null = no period, no filtering.
 *
 * Kept beside the builder's other contexts (reportBuilder2/context), the
 * same local convention as ReportBrandingContext.
 *
 * @type {React.Context<PeriodRange|null>}
 */
export const ReportPeriodContext = createContext(/** @type {PeriodRange|null} */ (null));

export default ReportPeriodContext;
